import { render } from "./Inmuebles.vue?vue&type=template&id=730866a8&scoped=true"
import script from "./Inmuebles.vue?vue&type=script&lang=js"
export * from "./Inmuebles.vue?vue&type=script&lang=js"

import "./Inmuebles.vue?vue&type=style&index=0&id=730866a8&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Public\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-730866a8"]])

export default __exports__